import store from "@/store";
import {PopupEnum} from "@/util/EnumUtil";
import {isEmpty} from "@/util/Helpers";


export function updateData(targetArray, sourceArray, modalId, index) {
    if (modalId !== PopupEnum.CREATE.id) {
        if (index !== -1) {
            if (modalId === PopupEnum.DELETE.id) {
                Object.assign(targetArray[index], null)
                targetArray.splice(index, 1)
            } else {
                Object.assign(targetArray[index], sourceArray)
                targetArray.splice(index, 1, sourceArray)
            }
        }
    } else {
        targetArray.push(sourceArray)
    }
    return targetArray
}

export function tableVisibility(fields) {
    return fields.filter(s => {
        if (Object.prototype.hasOwnProperty.call(s, 'visible')) {
            if (s.visible !== false) {
                return s
            }
        } else {
            return s
        }
    })
}

export function transformSelectOptions(data, text, emptyText) {
    let factoriesSelectList = []
    let defaultText = 'Επιλέξτε τιμή..'
    if (!isEmpty(data)) {
        factoriesSelectList.push({
            value: null,
            text: emptyText !== undefined ? emptyText : defaultText,
            defaultText: true
        })
        data.forEach((factory) => {
            if ((Object.prototype.hasOwnProperty.call(factory, 'isActive') && (!factory.isActive || factory.isActive != 0))
                || !Object.prototype.hasOwnProperty.call(factory, 'isActive')) {
                let selectListOption = {
                    value: factory,
                    text: factory[text],
                    defaultText: false
                }
                factoriesSelectList.push(selectListOption)
            }
        })
    }
    return factoriesSelectList
}

export const splitAdtAgmValues = (adtAgmWithGrammata) => {
    let result = {
        grammata: null,
        agm: null
    };
    adtAgmWithGrammata = adtAgmWithGrammata.trim().replace(/ /g, "");
    if (adtAgmWithGrammata === "--") {
        result.push(adtAgmWithGrammata);
    } else {
        let adtGrammataPart = adtAgmWithGrammata.toString().match(/^[Α-Ω A-Z]+/g);
        adtGrammataPart = (adtGrammataPart && adtGrammataPart[0]) || adtAgmWithGrammata.split('-')[0];
        if (adtAgmWithGrammata.split('-').length === 1 && parseInt(adtGrammataPart, 10)) {
            result.agm = '';
            result.grammata = adtGrammataPart;
        } else {
            result.grammata = adtGrammataPart;
            result.agm = adtAgmWithGrammata.replace(adtGrammataPart, "").replace("-", "").trim();
        }
    }
    return result;
};


export const toggleBusy = async (isBusy) => {
    if (store.getters['isBusy'] !== isBusy) {
        await store.dispatch("isBusy", isBusy);
    }
}


export const makeToast = (instance, message, variant, title) => {
    instance.$bvToast.toast(message, {
        title: !isEmpty(title) ? title : 'Σφάλμα οθόνης',
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-center',
        appendToast: true
    })
}

export const alertModal = (instance, message, options, type, id) => {
    if (type === 'msgBoxOk' || type === 'msgBoxConfirm') {
        if (isEmpty(options)) {
            options = {
                size: "md",
                buttonSize: 'md',
                headerClass: 'p-2 border-bottom-2 border-bottom  border-light',
                footerClass: 'p-2 border-top-2 border-top  border-light',
                cancelTitle: 'Όχι',
                okTitle: 'Ναι',
                cancelVariant: 'danger',
                okVariant: 'success',
                contentClass: 'text-dark font-weight-bolder',
            }
        }
        if (isEmpty(message)) {
            message = 'Κάτι πήγε στραβά. Παρακαλώ προσπαθήστε ξανά. Αν το πρόβλημα συνεχιστεί, παρακαλώ επικοινωνήστε με το αρμόδιο τμήμα. '
        }
        const h = instance.$createElement
        const titleVNode = h('div', {class: ['text-white'], domProps: {innerHTML: options.title}})
        const contentVNode = h('div', {domProps: {innerHTML: message}})
        return instance.$bvModal[type]([contentVNode], {
            id: id ? id : "modal-id",
            title: options.title ? [titleVNode] : null,
            size: options.size,
            buttonSize: options.buttonSize,
            headerClass: options.headerClass,
            footerClass: options.footerClass,
            cancelTitle: options.cancelTitle,
            okTitle: options.okTitle,
            cancelVariant: options.cancelVariant,
            okVariant: options.okVariant,
            contentClass: options.contentClass,
            centered: true
        })
    } else {
        return null
    }
}

export const deleteItemByIndex = (items, index) => {
    Object.assign(items[index], null)
    items.splice(index, 1)
    return items
}

export const updateItemByIndex = (items, index, data) => {
    Object.assign(items[index], data)
    items.splice(index, 1, data)
    return items
}

export const getAllIdiothtes = (obj) => {
    let newObject = null
    if (Object.prototype.hasOwnProperty.call(obj, 'parentId')) {
        store.getters['lookups/getIdiothta'].filter(obj1 => {
            if (!isEmpty(obj1.value)) {
                if (Object.prototype.hasOwnProperty.call(obj1.value, 'parentId')) {
                    if (obj.parentId === obj1.value.t048Id) {
                        newObject = obj1.value
                    }
                } else {
                    if (obj.parentId === obj1.value.t048Id) {
                        newObject = obj1.value
                    }
                }
            }
        })
    }
    return newObject
}
export const transformIdiothtes = (data) => {
    data.forEach(row => {
        let obj = []
        obj = [...obj, store.getters['lookups/getIdiothta'].filter(x => {
            if (!isEmpty(x.value)) {
                if (row.idiothtaT048.t048Id === x.value.t048Id) {
                    return x
                }
            }
        })[0].value]
        if (!isEmpty(obj[0])) {
            let obj1 = []
            obj1 = getAllIdiothtes(obj[0])
            if (!isEmpty(obj1)) {
                obj = [...obj, obj1]
                let obj2 = getAllIdiothtes(obj[1])
                if (!isEmpty(obj2)) {
                    obj = [...obj, obj2]
                    let obj3 = getAllIdiothtes(obj[2])
                    if (!isEmpty(obj3)) {
                        obj = [...obj, obj3]
                    }
                }
            }
        }
        let len = obj.length - 1
        for (let i = 0; i < obj.length; i++) {
            if (i === 0) {
                row['idiothta'] = obj[len - i]
            } else {
                row['idiothta' + (i)] = obj[len - i]
            }
        }
    })
    return data
}